import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px" }}>
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> January 2026</p>

      <p>
        This Privacy Policy explains how the Automate Poshmark Listing Creation
        Chrome extension handles user data.
      </p>

      <h3>Information Collection</h3>
      <p>
        This extension does not collect, store, transmit, or sell any personal
        or sensitive user data.
      </p>

      <h3>How the Extension Works</h3>
      <p>
        The extension assists users by helping auto-fill listing information
        on the Poshmark listing page after the user manually logs in.
        All actions occur locally within the user’s browser.
      </p>

      <h3>Data Usage</h3>
      <ul>
        <li>No personally identifiable information is collected</li>
        <li>No authentication credentials are accessed or stored</li>
        <li>No browsing history is tracked</li>
        <li>No data is transmitted to external servers</li>
      </ul>

      <h3>Third-Party Services</h3>
      <p>
        This extension is an independent tool and is not affiliated with,
        endorsed by, or sponsored by Poshmark.
      </p>

      <h3>User Control</h3>
      <p>
        All actions are initiated by the user. Users remain fully in control
        of submitting listings.
      </p>

      <h3>Contact</h3>
      <p>Email: support@yourdomain.com</p>
    </div>
  );
};

export default PrivacyPolicyPage;
